export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successfully Completed"])}
      },
      "fr": {
        "completed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complété"])}
      }
    }
  })
}
